import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Form,
  Button,
  Alert,
  InputGroup,
  Spinner,
  CardGroup,
  Card,
  Modal,
  Col
} from "react-bootstrap";
import { getKeywords, searchArtworks, tagImage, doUploadImg, isUserAdmin, APIGetMaxYear } from "../../api";
import LocalizedStrings from 'react-localization';
import localizedStrings from '../../strings';
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CardsView from "../CardsView";
import TableView from "../TableView";
import FileUpload from "../fileUpload";

const minRange = moment({ year: 1897, month: 0 });
const views = Object.freeze({ "TableView": 1, "CardsView": 2 })


let strings = new LocalizedStrings(localizedStrings);

function Homepage({ onLogout }) {
  const [maxRange, setMaxRange] = useState(moment({ year: 2025, month: 11 }));
  const [isAdmin, setIsAdmin] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [noArtworksFound, setNoArtworksFound] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [next, setNext] = useState(0);
  const [dbsize, setDbsize] = useState(0);
  const [totalSearch, setTotalSearch] = useState(0);
  const [artworks, setArtworks] = useState([]);
  const [selImage, setSelImage] = useState(null);
  const [showEditKeywords, setShowEditKeywords] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [availKeywords, setAvailKeywords] = useState(null);
  const [showAvailKeywords, setShowAvailKeywords] = useState(false);

  const [language, setLanguage] = useState("");
  const [textDir, setTextDir] = useState("RTL");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [yearOverlayFor, setYearOverlayFor] = useState(null);
  const [yearOverlayCurrent, setYearOverlayCurrent] = useState(minRange.year());

  const [viewType, setViewType] = useState(views.CardsView);
  const [isRandom, setIsRandom] = useState(false);

  const [miniMode, setMiniMode] = useState(false);
  const [exactMatch, setExactMatch] = useState(true);

  const scrollRef = useRef(null);
  // const toMonthEngRef = useRef(null);
  // const toYearEngRef = useRef(null);
  // const fromMonthEngRef = useRef(null);
  // const fromYearEngRef = useRef(null);

  const windowWidth = useRef(window.innerWidth);
  const windowHeight = useRef(window.innerHeight);

  console.log('width: ', windowWidth.current);
  console.log('height: ', windowHeight.current);

  useEffect(() => {
    onLanguageChanged("heb")
    checkIfAdmin()
    updateMaxYear()

    //strings.setLanguage(language);
    //onSearchArtworks();
    // getKeywords()
    //   .then(resp => {
    //     console.log(resp)
    //     let str = "";
    //     resp.forEach(keyword => str += (keyword + " "))
    //     setAvailKeywords(str)
    //   })
  }, [])

  //const handleCloseEditKeywords = () => { setSelImage(null); setTagKeywords(""); setShowEditKeywords(false); }

  const handleCloseUpload = () => { setShowUpload(false); }

  // const handleShowEditKeywords = (image) => { setSelImage(image); setTagKeywords(image.Keywords); setShowEditKeywords(true) }


  const onFromDateChanged = (date) => { setIsRandom(false); setFromDate(date); }
  const onToDateChanged = (date) => { setIsRandom(false); setToDate(date); }

  const openYearOverlay = (pickerType, currentYear) => {
    setYearOverlayFor(pickerType);
    setYearOverlayCurrent(currentYear);
  };

  const closeYearOverlay = () => {
    setYearOverlayFor(null);
  };

  const onSelectYear = (year) => {
    if (yearOverlayFor === "from") {
      const nextDate = fromDate ? moment(fromDate).year(year) : moment({ year, month: 0 });
      setFromDate(nextDate.toDate());
    } else if (yearOverlayFor === "to") {
      const nextDate = toDate ? moment(toDate).year(year) : moment({ year, month: 11 });
      setToDate(nextDate.toDate());
    }
    closeYearOverlay();
  };

  const renderPickerHeader = (pickerType) => ({ date }) => (
    <div className="month-picker-header" dir={textDir}>
      <button
        type="button"
        className="month-picker-year-button"
        onClick={() => openYearOverlay(pickerType, date.getFullYear())}
      >
        {date.getFullYear()}
      </button>
    </div>
  );

  const onClearSearch = (event) => {
    setFromDate(null);
    setToDate(null);
    setKeyword("");
    setIsRandom(false);

    setArtworks([]);
    setNext(0)
    setTotalSearch(0)
    setDbsize(0)
    setNoArtworksFound(false);
    //setTimeout(function(){ onSearchArtworks(); }, 500);
    setIsFirstLoad(true);
    setExactMatch(true);
  }

  const checkIfAdmin = async () => {
    let admin = await isUserAdmin()
    setIsAdmin(admin)
  }

   const updateMaxYear = async () => {
    console.log("calling updateMaxYear")
    const response = await APIGetMaxYear();
    console.log("updateMaxYear: " + response.data.max_year);
    const nextMaxRange = moment({ year: response.data.max_year, month: 11 });
    setMaxRange(nextMaxRange);
   }

  const onChangeKeyword = (event) => {
    setKeyword(event.target.value);
    setIsRandom(false);
  };

  const handleCloseUploading = () => {
    setIsUploading(false)
  }

  const onUpload = async (fileToUpload, thumb, caption, notes, tagsArray, fileDate) => {
    try {
      setShowUpload(false)
      setIsUploading(true)

      console.log(`${fileToUpload.name}, ${fileDate}`);

      let ret = await doUploadImg(fileToUpload, thumb, caption, notes, tagsArray, fileDate);
      setIsUploading(false)
      console.log(ret)

    } catch (e) {
      setIsUploading(false)
      console.log(e)
      alert("Upload error: " + e);
    }
  };

  const onLanguageChanged = (lang) => {
    console.log("onLanguageChanged: " + lang);
    strings.setLanguage(lang);
    setTextDir(lang === "heb" ? "RTL" : "LTR")
    setLanguage(lang);
  };

  const onSearchArtworks = async () => {
    setIsFirstLoad(false);
    setIsLoading(true);
    setArtworks([]);
    setTotalSearch(0);
    setNext(0)
    let keys = isRandom ? "randomize" : (keyword && keyword.length ? keyword : "")

    let from = fromDate ? moment(fromDate).startOf("month") : null;
    let to = toDate ? moment(toDate).endOf("month") : null;

    console.log(from + " -- " + to);

    const searchRet = await searchArtworks({ keyword: keys, next: -1, from: from ? from.valueOf() : null, to: to ? to.valueOf() : null, exact_match: exactMatch });
    console.log(searchRet)
    setIsLoading(false);
    if (searchRet) {
      setArtworks(searchRet.data);
      setNext(searchRet.next)
      setTotalSearch(searchRet.total_search)
      setDbsize(searchRet.dbsize)
      let noArtwork = !searchRet || !searchRet.data || !searchRet.data.length;
      setNoArtworksFound(noArtwork);
      setMiniMode(!noArtwork)
      if (scrollRef.current) {
        scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const onNext = async (event) => {
    event.preventDefault();
    onNextInter();
  }
  const onNextInter = async (event) => {
    setIsLoading(true);
    let keys = isRandom ? "randomize" : (keyword && keyword.length ? keyword : "")

    let from = fromDate ? moment(fromDate).startOf("month") : null;
    let to = toDate ? moment(toDate).endOf("month") : null;

    console.log(from + " -- " + to);
    const searchRet = await searchArtworks({ keyword: keys, next: next, from: from ? from.valueOf() : null, to: to ? to.valueOf() : null, exact_match: exactMatch });
    if (searchRet) {
      setArtworks(artworks.concat(searchRet.data));
      setNext(searchRet.next)
    }
    setIsLoading(false);
  };


  // const onEditKeywords = async (event) => {
  //   event.preventDefault();
  //   setShowEditKeywords(false)
  //   setIsLoading(true);

  //   console.log(selImage);

  //   let result = await tagImage(selImage, tagKeywords);

  //   if (result === "") {
  //     selImage.Keywords = tagKeywords
  //   }

  //   setIsLoading(false);
  //   setSelImage(null);
  //   setTagKeywords("");

  //   alert(result === "" ? "Changes Saved!" : result);
  // };

  return (
    <Container fluid>
      {/* <h1>{process.env.NODE_ENV}</h1>
      <h1>{process.env.REACT_APP_NOT_SECRET_CODE}</h1>
      <h1>{process.env.REACT_AWS_DEPLOYMENT ? process.env.REACT_AWS_DEPLOYMENT : "no process.env.REACT_AWS_DEPLOYMENT"}</h1> */}
      <Row className="mt-2 mb-2 justify-content-end" noGutters>
        {!miniMode &&
          <Button variant="outline-danger" onClick={onLogout} style={{ marginRight: "10px" }}>
            {strings.logOut}
          </Button>
        }
        {!miniMode && isAdmin &&
          <Button variant="outline-primary" onClick={() => setShowUpload(true)} style={{ marginRight: "10px" }}>
            {strings.upload}
          </Button>
        }
        {!miniMode &&
          <Button variant="outline-secondary" onClick={() => onLanguageChanged("en")}>
            <img src="USA-Flag-icon.png" alt="English" />
          </Button>
        }
        {!miniMode &&
          <Button variant="outline-secondary" onClick={() => onLanguageChanged("heb")}>
            <img src="Israel-Flag-icon.png" alt="עברית" />
          </Button>
        }
      </Row>
      <Row noGutters>
        <h1 style={{ margin: "auto" }}>{strings.Welcome}</h1>
      </Row>
      <Row noGutters>
        <Form className="mb-2" style={{ maxWidth: "500px", margin: "auto" }} onSubmit={(event) => { event.preventDefault(); onSearchArtworks() }}>
          <InputGroup>
            <Button
              variant="outline-primary"
              disabled={false}
              onClick={() => setMiniMode(!miniMode)}
            >
              <i class="fa fa-bars"></i>
            </Button>

            {!isFirstLoad && <Button
              variant="outline-primary"
              disabled={false}
              onClick={onClearSearch}

            >
              <i class="fa fa-remove"></i>
            </Button>
            }
            <Form.Control
              type="text"
              placeholder={strings.multiple_keywords}
              onChange={onChangeKeyword}
              value={keyword}
              dir={textDir}

            />
            <Button
              variant="outline-primary"
              disabled={false}
              type="submit"
            >
              <i class="fa fa-search"></i>
            </Button>
            <InputGroup
              style={{ display: miniMode ? 'none' : 'flex' }}
              className={`month-year-range-group ${strings.getLanguage() === "heb" ? "rtl" : "ltr"}`}
              dir={textDir}
            >
              {(strings.getLanguage() === "heb") ? (
                <>
                  <DatePicker
                    key="from-heb-month-year"
                    selected={fromDate}
                    onChange={onFromDateChanged}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    renderCustomHeader={renderPickerHeader("from")}
                    isClearable
                    placeholderText={strings.from}
                    className="form-control month-year-picker"
                    minDate={minRange.toDate()}
                    maxDate={maxRange.toDate()}
                    popperPlacement="bottom-end"
                    openToDate={fromDate || moment({ year: maxRange.year(), month: 0 }).toDate()}
                  />
                  <div className="picker-direction-arrow" aria-hidden="true">
                    <i className="fa fa-arrow-right"></i>
                  </div>
                  <DatePicker
                    key="to-heb-month-year"
                    selected={toDate}
                    onChange={onToDateChanged}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    renderCustomHeader={renderPickerHeader("to")}
                    isClearable
                    placeholderText={strings.to}
                    className="form-control month-year-picker"
                    minDate={minRange.toDate()}
                    maxDate={maxRange.toDate()}
                    popperPlacement="bottom-end"
                    openToDate={toDate || moment({ year: maxRange.year(), month: 11 }).toDate()}
                  />
                </>
              ) : (
                <>
                  <DatePicker
                    key="from-en-month-year"
                    selected={fromDate}
                    onChange={onFromDateChanged}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    renderCustomHeader={renderPickerHeader("from")}
                    isClearable
                    placeholderText={strings.from}
                    className="form-control month-year-picker"
                    minDate={minRange.toDate()}
                    maxDate={maxRange.toDate()}
                    popperPlacement="bottom-start"
                    openToDate={fromDate || moment({ year: maxRange.year(), month: 0 }).toDate()}
                  />
                  <div className="picker-direction-arrow" aria-hidden="true">
                    <i className="fa fa-arrow-right"></i>
                  </div>
                  <DatePicker
                    key="to-en-month-year"
                    selected={toDate}
                    onChange={onToDateChanged}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    renderCustomHeader={renderPickerHeader("to")}
                    isClearable
                    placeholderText={strings.to}
                    className="form-control month-year-picker"
                    minDate={minRange.toDate()}
                    maxDate={maxRange.toDate()}
                    popperPlacement="bottom-start"
                    openToDate={toDate || moment({ year: maxRange.year(), month: 11 }).toDate()}
                  />
                </>
              )}
            </InputGroup>

            {yearOverlayFor && (
              <div className="year-overlay-backdrop" onClick={closeYearOverlay}>
                <div className="year-overlay-panel" dir={textDir} onClick={(event) => event.stopPropagation()}>
                  <div className="year-overlay-header">
                    <span>{yearOverlayFor === "from" ? strings.from : strings.to}</span>
                    <Button variant="outline-secondary" size="sm" onClick={closeYearOverlay}>×</Button>
                  </div>
                  <div className="year-overlay-list">
                    {Array.from({ length: maxRange.year() - minRange.year() + 1 }, (_, idx) => minRange.year() + idx)
                      .reverse()
                      .map((year) => (
                        <button
                          key={`year-${year}`}
                          type="button"
                          className={`year-overlay-item ${year === yearOverlayCurrent ? "active" : ""}`}
                          onClick={() => onSelectYear(year)}
                        >
                          {year}
                        </button>
                      ))}
                  </div>
                </div>
              </div>
            )}

            {/* <Button
              variant="outline-primary"
              disabled={false}
              type="submit"
              style={{ width: "100%" }}
            >
              {strings.SearchDB}
            </Button> */}
          </InputGroup>

          {!miniMode && (
            <label
              htmlFor="exact-match-checkbox"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '2px 4px',
                cursor: 'pointer',
                margin: 0,
                userSelect: 'none',
                justifyContent: strings.getLanguage() === 'heb' ? 'flex-end' : 'flex-start',
              }}
            >
              <input
                type="checkbox"
                id="exact-match-checkbox"
                checked={exactMatch}
                onChange={(e) => setExactMatch(e.target.checked)}
                style={{ cursor: 'pointer', flexShrink: 0 }}
              />
              <span>{strings.exact_match}</span>
            </label>
          )}

          {!isFirstLoad && artworks.length > 0 && (
            <Row className="mt-2" noGutters>
              <h5 style={{ margin: "auto", fontSize: "small" }}>{strings.formatString(strings.searchStats, totalSearch, artworks.length)}</h5>
            </Row>
          )}
          {/* <Row noGutters>
            <small>
              <i style={{ margin: "10px" }} className="fa fa-arrow-right" aria-hidden="true"></i>
              Use '+' sign to search for all keywords
              {strings.multiple_keywords}
            </small>
          </Row> */}
          {/* {availKeywords && <Row noGutters>
            {!showAvailKeywords && <small>
              <i style={{ margin: "10px" }} className="fa fa-plus-square" aria-hidden="true" onClick={() => setShowAvailKeywords(!showAvailKeywords)}></i>
              Show keywords
            </small>
            }
            {showAvailKeywords && <small>
              <i style={{ margin: "10px" }} className="fa fa-minus-square" aria-hidden="true" onClick={() => setShowAvailKeywords(!showAvailKeywords)}></i>
              Hide keywords
            </small>
            }
          </Row>
          }
          {availKeywords && showAvailKeywords && <Row noGutters>
            <small>
              {availKeywords}
            </small>
          </Row>
          } */}
        </Form>
      </Row >
      {!isFirstLoad && isLoading && !noArtworksFound && (!artworks.length) &&
        <Row className="justify-content-center mb-5">
          <Spinner animation="border" variant="primary" />
        </Row>

      }
      {
        !isFirstLoad && noArtworksFound && !isLoading &&
        <Alert variant={"info"} style={{ textAlign: "center" }}>
          {strings.noResults}
        </Alert>
      }
      {!isFirstLoad && !noArtworksFound && !isLoading && !miniMode &&
        <Row className="w-100 mb-3 justify-content-center" noGutters>
          <Button variant="outline-secondary" onClick={() => setViewType(views.TableView)}>
            <img src="table.png" alt="table view" />

          </Button>
          <Button variant="outline-secondary" onClick={() => setViewType(views.CardsView)}>
            <img src="thumbs.png" alt="thumbs view" />
          </Button>

        </Row>
      }
      {!isFirstLoad && !noArtworksFound &&
        <Row className="w-100 resultsParent" id="scrollableDiv" noGutters
          ref={scrollRef}
          style={{ height: miniMode ? "calc(100vh - 140px)" : "calc(100vh - 260px)" }}>
          {(viewType == views.CardsView) ? <CardsView fetchMoreData={onNextInter} maxData={totalSearch} artworks={artworks} strings={strings} /> :
            <TableView fetchMoreData={onNextInter} maxData={totalSearch} artworks={artworks} strings={strings} />}
        </Row>
      }
      {/*
        !isFirstLoad && !isLoading && (
          <Row className="mt-2 mb-5" noGuttersnoGutters>
            <h5 style={{ margin: "auto" }}>{strings.formatString(strings.searchStats, totalSearch, artworks.length)}</h5>
          </Row>
        )
        */}
      {/*
        !isFirstLoad && !isLoading && !noArtworksFound && next > 0 &&
        <Row noGutters>
          <Form className="w-100 mb-5" onSubmit={onNext} style={{ margin: "auto" }}>
            <InputGroup>
              <InputGroup.Prepend style={{ margin: "auto" }}>
                <Button
                  variant="outline-primary"
                  type="submit"
                >
                  {strings.moreResults}
                </Button>
              </InputGroup.Prepend>
            </InputGroup>
          </Form>
        </Row>
      */}
      {/*
        selImage && showEditKeywords &&
        <Modal
          show={showEditKeywords}
          onHide={handleCloseEditKeywords}
        >
          <Modal.Header closeButton>
            <Modal.Title>{selImage.Caption}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container fluid>
              <Row className="mt-2" noGutters>
                <h6>
                  {strings.tagPic}
                </h6>
              </Row>
              <Row noGutters>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="=> yos, ruty, mom..."
                    onChange={onChangeTagKeywords}
                    value={tagKeywords}
                  />
                </InputGroup>
              </Row>

            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={onEditKeywords}>{strings.save}</Button>
            <Button variant="secondary" onClick={handleCloseEditKeywords}>{strings.close}</Button>
          </Modal.Footer>
        </Modal>
    */}
      {showUpload && <FileUpload onHide={handleCloseUpload} onUpload={onUpload} language={language} textDir={textDir}> </FileUpload>}
      <Modal
        show={isUploading}
        backdrop="static"
        onHide={handleCloseUploading}
      >
        <Modal.Header>
          <Modal.Title>{strings.uploading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row className="justify-content-center mb-5">
              <Spinner animation="border" variant="primary" />
            </Row>
          </Container>
        </Modal.Body>
      </Modal>


    </Container >
  );
}

export default Homepage;
